export default __webpack_public_path__ + "a5a2abbb5ad108246f765381665904b1.svg";